module.exports = __webpack_public_path__ + "static/media/bin.1aafb567.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bin.svg
// module id = 159
// module chunks = 21